"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Variants = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Label = require("./Label");
var _VariantList = require("./VariantList");
require("./Variants.scss");
var _excluded = ["className", "text", "variants", "variantCount"];
var Variants = function Variants(_ref) {
  var className = _ref.className,
    text = _ref.text,
    variants = _ref.variants,
    variantCount = _ref.variantCount,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var Label = Variants.Label,
    VariantList = Variants.VariantList;
  if (!Array.isArray(variants) || !variants.length) {
    return null;
  }
  var rootClassName = (0, _classnames["default"])('cds-ProductBox-Variants', className);
  var visibleVariantCount = Math.min(variantCount, variants.length);
  var visibleVariants = variants.slice(0, visibleVariantCount);
  var moreVariantCount = variants.length - visibleVariantCount;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: rootClassName
  }, /*#__PURE__*/_react["default"].createElement(Label, null, text.variants), /*#__PURE__*/_react["default"].createElement(VariantList, (0, _extends2["default"])({}, props, {
    moreVariantCount: moreVariantCount,
    text: text,
    variants: visibleVariants
  })));
};
exports.Variants = Variants;
Variants.Label = _Label.Label;
Variants.VariantList = _VariantList.VariantList;